import React, { useState } from "react";
import PrimaryButton from "../../custom/PrimaryButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

const ButtonMenu = (props) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    if (props?.menuSingleItem) {
      setAnchorEl(null);
    } else {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //   const handleCloseType = (type) => {
  //     if (type === "card") {
  //       setAnchorEl(props?.menuCardAction);
  //     } else if (type === "bank") {
  //       setAnchorEl(props?.menuBankAction);
  //     } else {
  //       setAnchorEl(null);
  //     }
  //   };

  return (
    <div>
      <PrimaryButton
        id="basic-button"
        disabled={props?.menuDisabled}
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={props?.menuSingleItem ? props?.menuCardAction : handleClick}
      >
        {props?.menuName}
      </PrimaryButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuItem onClick={props?.menuCardAction}>
          Credit card/ SEPA debit
        </MenuItem>
        <MenuItem onClick={props?.menuBankAction}>Bank transfer</MenuItem>
      </Menu>
    </div>
  );
};

export default ButtonMenu;
